// extracted by mini-css-extract-plugin
export var locationCard = "_dp-0";